import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "form-field-floating lg reactive my-5" }
const _hoisted_2 = ["readonly"]
const _hoisted_3 = { class: "form-field-floating lg reactive my-5" }
const _hoisted_4 = ["readonly"]
const _hoisted_5 = { class: "mt-7" }
const _hoisted_6 = {
  key: 0,
  class: "text-red text-center mb-5"
}
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "s14" }

import { reactive, ref } from 'vue';
    import axios from 'axios';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'LoginForm',
  emits: ['authenticated'],
  setup(__props, { emit: __emit }) {

    const emit = __emit;

    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        username: '', 
        password: '',
    });
    const formErrors = reactive({
        username: '',
        password: '',
    });

    function validate() {
        let isValid = true;

        formErrors.username = '';
        if (!formData.username) {
            formErrors.username ="Le nom d'utilisateur est requis";
            isValid = false;
        }

        formErrors.password = '';
        if (!formData.password) {
            formErrors.password ="Le nom d'utilisateur est requis";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const httpResponse = await axios.post(`/backoffice/auth/signin`, formData);
            emit("authenticated", httpResponse.data);

            /*if (tokenHttpResponse.data.password_expired) {
                openRenewPasswordModal();
            } else if (tokenHttpResponse.data.mfa_enabled) {
                mfaAuthenticationModalRef.value?.open(accessToken.value);
            } else {
                await saveAuthSession(accessToken.value);
                await router.replace('/app/admins/list');
            }*/
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[6] || (_cache[6] = _createElementVNode("h1", { class: "font-semibold my-8 text-center" }, [
      _createTextVNode("Connexion "),
      _createElementVNode("span", { class: "text-sm text-grey-500" })
    ], -1)),
    _createElementVNode("form", {
      class: "form",
      onSubmit: _withModifiers(onSubmit, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.username) = $event)),
          name: "identifiant",
          id: "identifiant",
          placeholder: "",
          readonly: loading.value,
          autofocus: ""
        }, null, 8, _hoisted_2), [
          [_vModelText, formData.username]
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("label", { for: "identifiant" }, [
          _createTextVNode("Identifiant "),
          _createElementVNode("b", { class: "color-danger" }, "*")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "password",
          class: "form-input",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.password) = $event)),
          name: "password",
          id: "password",
          placeholder: "",
          readonly: loading.value
        }, null, 8, _hoisted_4), [
          [_vModelText, formData.password]
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("label", { for: "password" }, [
          _createTextVNode("Mot de passe "),
          _createElementVNode("b", { class: "color-danger" }, "*")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (!!errorMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_custom_button, {
              type: "submit",
              classesList: 'btn xl w-100',
              loading: loading.value
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createElementVNode("img", {
                  src: "/icons/icon-menu-securite.svg",
                  class: "btn-icon",
                  alt: ""
                }, null, -1),
                _createElementVNode("span", null, "Connexion", -1)
              ]))]),
              _: 1
            }, 8, ["loading"])
          ]),
          _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"s6 flex-right\"><label class=\"form-switch\"><div class=\"switch\"><input type=\"checkbox\" checked><span class=\"slider round\"></span></div><h6 class=\"label text-grey-600\">Rester connecté</h6></label></div>", 1))
        ])
      ])
    ], 32)
  ]))
}
}

})